import { defineMessages } from 'react-intl';

import {
	MentalHealthSectionTitle,
	MentalHealthSlide,
} from '@/components/homepageRefresh/homepage/MentalHealthTools/types';

export const messages = defineMessages({
	heading: {
		id: 'subpage.mindfulness.mentalHealthTools.heading',
		defaultMessage: 'Mindfulness tools for a calmer mind and a more fulfilling life.',
		description: 'Heading for section with the various mental health tools that Calm provides',
	},
	slide1Title: {
		id: 'subpage.mindfulness.mentalHealthTools.slide1.title',
		defaultMessage: 'For Beginners',
		description: 'Title for mental health tools slide',
	},
	slide1Heading: {
		id: 'subpage.mindfulness.mentalHealthTools.slide1.heading',
		defaultMessage: 'We make it easy to take the first step',
		description: 'Heading for mental health tools slide',
	},
	slide1Copy: {
		id: 'subpage.mindfulness.mentalHealthTools.slide1.copy',
		defaultMessage:
			"Meditation can be daunting, so we've demystified it. Our beginner programs help you learn the foundations, build on your successes, and integrate mindfulness into your day-to-day life.",
		description: 'Copy for mental health tools slide',
	},
	slide1ContentTitle: {
		id: 'subpage.mindfulness.mentalHealthTools.slide1.contentTitle',
		defaultMessage: 'Mindfulness for Beginners',
		description: "Title of slide's previewable content",
	},
	slide1ContentSubheading: {
		id: 'subpage.mindfulness.mentalHealthTools.slide1.contentSubheading',
		defaultMessage: 'A simple 30-day program for everyone',
		description: "Information for slide's previewable content",
	},
	slide1ContentAuthor: {
		id: 'subpage.mindfulness.mentalHealthTools.slide1.contentAuthor',
		defaultMessage: 'Narrated by Jeff Warren',
		description: "Author of slide's previewable content",
	},
	slide2Title: {
		id: 'subpage.mindfulness.mentalHealthTools.slide2.title',
		defaultMessage: 'Daily Mindfulness',
		description: 'Title for mental health tools slide',
	},
	slide2Heading: {
		id: 'subpage.mindfulness.mentalHealthTools.slide2.heading',
		defaultMessage: 'Make mindfulness a daily habit',
		description: 'Heading for mental health tools slide',
	},
	slide2Copy: {
		id: 'subpage.mindfulness.mentalHealthTools.slide2.copy',
		defaultMessage:
			'Build healthy habits that will last a lifetime. Our daily programs are designed to fit into your lifestyle in practical ways, giving your day a dose of mindfulness, wisdom, and encouragement. ',
		description: 'Copy for mental health tools slide',
	},
	slide2ContentTitle: {
		id: 'subpage.mindfulness.mentalHealthTools.slide2.contentTitle',
		defaultMessage: 'Daily Calm',
		description: "Title of slide's previewable content",
	},
	slide2ContentSubheading: {
		id: 'subpage.mindfulness.mentalHealthTools.slide2.contentSubheading',
		defaultMessage: 'Explore the benefits of simply being',
		description: "Information for slide's previewable content",
	},
	slide2ContentAuthor: {
		id: 'subpage.mindfulness.mentalHealthTools.slide2.contentAuthor',
		defaultMessage: 'Narrated by Tamara Levitt',
		description: "Author of slide's previewable content",
	},
	slide3Title: {
		id: 'subpage.mindfulness.mentalHealthTools.slide3.title',
		defaultMessage: 'Daily Wisdom',
		description: 'Title for mental health tools slide',
	},
	slide3Heading: {
		id: 'subpage.mindfulness.mentalHealthTools.slide3.heading',
		defaultMessage: 'Become the person you want to be',
		description: 'Heading for mental health tools slide',
	},
	slide3Copy: {
		id: 'subpage.mindfulness.mentalHealthTools.slide3.copy',
		defaultMessage:
			'Spend 7 minutes a day with Jay Shetty, and watch all the ways your life changes. Jay keeps it fun and fresh, with sessions on prioritization, purpose, self-talk, and more.',
		description: 'Copy for mental health tools slide',
	},
	slide3ContentTitle: {
		id: 'subpage.mindfulness.mentalHealthTools.slide3.contentTitle',
		defaultMessage: 'Daily Jay',
		description: "Title of slide's previewable content",
	},
	slide3ContentSubheading: {
		id: 'subpage.mindfulness.mentalHealthTools.slide3.contentSubheading',
		defaultMessage: 'Learning to live with that voice inside your head',
		description: "Information for slide's previewable content",
	},
	slide3ContentAuthor: {
		id: 'subpage.mindfulness.mentalHealthTools.slide3.contentAuthor',
		defaultMessage: 'Narrated by Jay Shetty',
		description: "Author of slide's previewable content",
	},
	slide4Title: {
		id: 'subpage.mindfulness.mentalHealthTools.slide4.title',
		defaultMessage: 'Quick Meditations',
		description: 'Title for mental health tools slide',
	},
	slide4Heading: {
		id: 'subpage.mindfulness.mentalHealthTools.slide4.heading',
		defaultMessage: 'Learn mindfulness 2 minutes at a time',
		description: 'Heading for mental health tools slide',
	},
	slide4Copy: {
		id: 'subpage.mindfulness.mentalHealthTools.slide4.copy',
		defaultMessage:
			"Calm's Quick Meditations are the easiest way to get started. These guided sessions are as short as 1 to 2 minutes, and you can choose from a variety of voices and techniques.",
		description: 'Copy for mental health tools slide',
	},
	slide4ContentTitle: {
		id: 'subpage.mindfulness.mentalHealthTools.slide4.contentTitle',
		defaultMessage: 'One-Minute Reset',
		description: "Title of slide's previewable content",
	},
	slide4ContentSubheading: {
		id: 'subpage.mindfulness.mentalHealthTools.slide4.contentSubheading',
		defaultMessage: 'Take a few deep, deliberate breaths to reset',
		description: "Information for slide's previewable content",
	},
	slide4ContentAuthor: {
		id: 'subpage.mindfulness.mentalHealthTools.slide4.contentAuthor',
		defaultMessage: 'Narrated by Chibs Okereke',
		description: "Author of slide's previewable content",
	},
	slide5Title: {
		id: 'subpage.mindfulness.mentalHealthTools.slide5.title',
		defaultMessage: 'Courses',
		description: 'Title for mental health tools slide',
	},
	slide5Heading: {
		id: 'subpage.mindfulness.mentalHealthTools.slide5.heading',
		defaultMessage: 'Step-by-step guidance to support your growth',
		description: 'Heading for mental health tools slide',
	},
	slide5Copy: {
		id: 'subpage.mindfulness.mentalHealthTools.slide5.copy',
		defaultMessage:
			'Our popular courses help integrate mindfulness into different aspects of your life, like building confidence, improving relationships, and breaking bad habits.',
		description: 'Copy for mental health tools slide',
	},
	slide5ContentTitle: {
		id: 'subpage.mindfulness.mentalHealthTools.slide5.contentTitle',
		defaultMessage: 'The Confidence Series',
		description: "Title of slide's previewable content",
	},
	slide5ContentSubheading: {
		id: 'subpage.mindfulness.mentalHealthTools.slide5.contentSubheading',
		defaultMessage: "Meditations to prepare for life's key moments, like starting the day",
		description: "Information for slide's previewable content",
	},
	slide5ContentAuthor: {
		id: 'subpage.mindfulness.mentalHealthTools.slide5.contentAuthor',
		defaultMessage: 'Narrated by Tamara Levitt',
		description: "Author of slide's previewable content",
	},
});

export const sections: Record<MentalHealthSectionTitle, MentalHealthSlide> = {
	forBeginners: {
		title: messages.slide1Title,
		heading: messages.slide1Heading,
		copy: messages.slide1Copy,
		contentTitle: messages.slide1ContentTitle,
		contentSubheading: messages.slide1ContentSubheading,
		contentUrl: '/app/player/7pB36yl4DL',
		author: messages.slide1ContentAuthor,
		imageUrl: '/_n/images/subpages/mindfulness-player-beginners.webp',
		audioSrc:
			'/_n/audio/subpages/MSER_0012-01_MindfulnessForBeginners_EN_2CH_MK_20230802_HomepageCutdown.mp3',
	},
	dailyMindfulness: {
		title: messages.slide2Title,
		heading: messages.slide2Heading,
		copy: messages.slide2Copy,
		contentTitle: messages.slide2ContentTitle,
		contentSubheading: messages.slide2ContentSubheading,
		contentUrl: '/app/player/rq54vF0Pir',
		author: messages.slide2ContentAuthor,
		imageUrl: '/_n/images/subpages/mindfulness-player-daily-calm.webp',
		audioSrc: '/_n/audio/subpages/DCLM_Being_EN_2CH_MK_20230802_HomepageCutdown.mp3',
	},
	dailyWisdom: {
		title: messages.slide3Title,
		heading: messages.slide3Heading,
		copy: messages.slide3Copy,
		contentTitle: messages.slide3ContentTitle,
		contentSubheading: messages.slide3ContentSubheading,
		contentUrl: '/app/player/LVuQ6Zz8Pb',
		author: messages.slide3ContentAuthor,
		imageUrl: '/_n/images/subpages/mindfulness-player-daily-jay.webp',
		audioSrc: '/_n/audio/subpages/DJAY_TheInnerCritic_EN_2CH_MK_20230822_HomepageCutdown.mp3',
	},
	quickMeditations: {
		title: messages.slide4Title,
		heading: messages.slide4Heading,
		copy: messages.slide4Copy,
		contentTitle: messages.slide4ContentTitle,
		contentSubheading: messages.slide4ContentSubheading,
		author: messages.slide4ContentAuthor,
		contentUrl: '/app/player/rOIJNzWCMS',
		imageUrl: '/_n/images/subpages/mindfulness-player-quick.webp',
		audioSrc: 'https://assets.calm.com/816674ae7ac5ed1a4e0576f378150500.m4a',
	},
	courses: {
		title: messages.slide5Title,
		heading: messages.slide5Heading,
		copy: messages.slide5Copy,
		contentTitle: messages.slide5ContentTitle,
		contentSubheading: messages.slide5ContentSubheading,
		author: messages.slide5ContentAuthor,
		contentUrl: '/app/player/1VSHka8-JZ',
		imageUrl: '/_n/images/subpages/mindfulness-player-courses.webp',
		audioSrc:
			'/_n/audio/subpages/MSER_TheConfidenceSeriesBeforeTheDayPurePossibility_EN_2CH_MK_20230802_HomepageCutdown.mp3',
	},
};
